import { Link } from "react-router-dom";

function Nopage() {
    return (
      <>
        <main>
          <h2>404</h2>
          <p>No page found under that URL.</p>
        </main>
        <nav>
          <Link to="/">Home</Link>
        </nav>
      </>
    );
}

export default Nopage;